import axios from "axios"
import { envConfig } from '../../../env';

const cotton = envConfig.formalServer + "/cotton"
// const cotton = 'https://server.cottongame.com/cotton'



/**
 * 获取时间是否在有效期内 
 * @param {*} params  id
 * @returns 
 */
export const getTaskTimingIsValid = params => axios.post(cotton + '/getTaskTimingIsValid', params)  

/**
 * 更新/新增定时任务
 * @param {*} params 更新时传id / 结束时间 endTime、 任务内容 taskMsg 
 * @returns 
 */
export const setTaskTiming = params => axios.post(cotton + '/setTaskTiming', params)  

/**
 * 获取定时任务列表 
 * @param {} params pageSize、pageCount
 * @returns 
 */
export const getTaskTimingList = params => axios.post(cotton + '/getTaskTimingList', params)



